// 请求工具函数

/**
 * 获取默认请求头
 * @param bizId 业务标识，默认为 "index"
 * @returns 默认请求头对象
 */
export function getDefaultHeaders(bizId: string = "index"): Record<string, string> {
  return {
    "Content-Type": "application/json",
    "biz": "index",
    "X-Biz-Id": bizId,
  }
}

/**
 * 获取文件上传请求头
 * @param bizId 业务标识，默认为 "index"
 * @returns 文件上传请求头对象
 */
export function getUploadHeaders(bizId: string = "index"): Record<string, string> {
  return {
    "Content-Type": "multipart/form-data",
    "X-Biz-Id": bizId,
  }
}

/**
 * 获取带认证的请求头
 * @param token JWT token
 * @param bizId 业务标识，默认为 "index"
 * @returns 带认证的请求头对象
 */
export function getAuthHeaders(token: string, bizId: string = "index"): Record<string, string> {
  return {
    ...getDefaultHeaders(bizId),
    "Authorization": `Bearer ${token}`,
  }
}

/**
 * 验证请求头是否包含必要的字段
 * @param headers 请求头对象
 * @returns 验证结果
 */
export function validateHeaders(headers: Record<string, string>): {
  isValid: boolean
  missing: string[]
} {
  const requiredHeaders = ["X-Biz-Id"]
  const missing: string[] = []
  
  for (const header of requiredHeaders) {
    if (!headers[header]) {
      missing.push(header)
    }
  }
  
  return {
    isValid: missing.length === 0,
    missing
  }
}

/**
 * 打印请求头信息（仅开发环境）
 * @param headers 请求头对象
 * @param url 请求URL
 */
export function logHeaders(headers: Record<string, string>, url: string): void {
  if (import.meta.env.MODE === "development") {
    console.log(`🔍 Request Headers for ${url}:`, headers)
  }
} 